import { React } from 'Imports';
import { Route } from 'react-router-dom';
import { PageTitleSetter } from '../utils/usePageTitleSetter';
import { VerifyRole } from '../../externals/VerifyRole';
import { standardProtectedRouteConfig, standardPublicRouteConfig } from './standard-route-config';

const StandardProtectedRoutes = () => {
    return (
        <>
            {standardProtectedRouteConfig.map((route) => {
                const { path, label, Component, allowedRoles } = route;

                return (
                    <Route
                        key={path}
                        path={path}
                        element={
                            <PageTitleSetter title={label}>
                                {allowedRoles ? (
                                    <VerifyRole allowedRole={allowedRoles} restrictedMessage={true}>
                                        <Component />
                                    </VerifyRole>
                                ) : (
                                    <Component />
                                )}
                            </PageTitleSetter>
                        }
                    />
                );
            })}
        </>
    );
};

const StandardPublicRoutes = () => {
    return (
        <>
            {standardPublicRouteConfig.map((route) => {
                const { path, label, Component } = route;

                return (
                    <Route
                        key={path}
                        path={path}
                        element={
                            <PageTitleSetter title={label}>
                                <Component />
                            </PageTitleSetter>
                        }
                    />
                );
            })}
        </>
    );
};

export { StandardProtectedRoutes, StandardPublicRoutes };
